import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import { QRCodeSVG } from 'qrcode.react'
import BigButton from 'components/buttons/bigButton'
import "./site.scss"
export default function Site() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Site Carrière",
            icon : "picto site carriere - v3.svg",
            color : "bckPink"
        })
    }, [])
    return (
        <div id="site" className='page'>
            <img src="/site.jpg" alt="" />
            <div className='w100 flex center column' style={{height : "700px"}}>
                <p>https://marque-employeur.chu-rouen.fr/</p>
                <br /><br /><br />
                <div className='w100 flex center'>
                        <div className='cadre'>
                            URL du site carrière
                        </div>
                        <QRCodeSVG value="https://marque-employeur.chu-rouen.fr/" fgColor='#215fa5' bgColor='none' className='qrcode' size={150} />
                </div>
            </div>
        </div>
    )
}
